<template>
  <div class="table-card__item-content"
       :class="{show: show}"
  >
    <div class="table-card__item-head">
      <div class="table-card__item-head-row d-flex">
        <div class="table-card__item-number table-card__item-number--small">
          #{{item.id}}
        </div>
      </div>
    </div>
    <transition name="slide">
      <div class="table-card__item-body"
           v-if="show"
      >
        <div class="table-card__item-row custom-row">
          <div class="table-card__item-col custom-col">
            <div class="table-card__item-label">
              {{ $t('forbiddenKeywords_ForbiddenGoodsKeyword.localization_value.value') }}
            </div>
            <div class="table-card__item-info">
              {{item.keyword}}
            </div>
          </div>
          <div class="table-card__item-col custom-col">
            <div class="table-card__item-label">
              {{ $t('forbiddenKeywords_ForbiddenGoodsKeyword.localization_value.value') }}
            </div>
            <div class="table-card__item-info">
              <div v-if="item.is_enabled === '1'"
                   v-bind:class="{'admin-edit-item': $store.getters.getUserProfile.isAdmin || checkImpersonate()}">
                <div class="admin-edit" @click="editTranslate(['forbiddenKeywords_Active'])"></div>
                <StatusIcoBtn class="mr-1" :type="'delivered'"/>
                {{ $t('forbiddenKeywords_Active.localization_value.value') }}
              </div>
              <div v-else
                   v-bind:class="{'admin-edit-item': $store.getters.getUserProfile.isAdmin || checkImpersonate()}">
                <div class="admin-edit" @click="editTranslate(['forbiddenKeywords_Inactive'])"></div>
                <StatusIcoBtn class="mr-1" :type="'cancel'"/>
                {{ $t('forbiddenKeywords_Inactive.localization_value.value') }}
              </div>
            </div>
          </div>
        </div>
        <div class="table-card__item-btn">
          <div class="table-card__item-btn-i">
            <LinkButton
                    :value="$t('common_edit.localization_value.value')"
                    :type="'edit'"
                    @click.native="$emit('changeForbiddenKeywordsPopup')"
            />
          </div>
          <div class="table-card__item-btn-i">
            <LinkButton
                    :value="$t('common_delete.localization_value.value')"
                    :type="'delete'"
                    @click.native="$emit('deleteItem')"
            />
          </div>
        </div>
      </div>
    </transition>
    <div class="table-card__item-footer">
      <div class="table-card__item-show"
           @click="show = !show"
      >
        {{$t('common_showMore.localization_value.value')}}
      </div>
    </div>
  </div>
</template>

<script>
  import LinkButton from "../../../../../../../UI/buttons/LinkButton/LinkButton";
  import StatusIcoBtn from "../../../../../../../UI/status/StatusIcoBtn/StatusIcoBtn";
  export default {
    name: "ForbiddenKeywordsTableMobile",
    components: {StatusIcoBtn, LinkButton},

    props: {
      item: Object,
    },

    data() {
      return {
        show: false,
      }
    }
  }
</script>

<style scoped>

</style>
